/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { AdminCreateCourseOptions, AdminCreateCourseResponses } from '../../models/AdminCreateCourse'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @summary Create Course
 * {@link /admin/course/create}
 */
export function adminCreateCourse<ThrowOnError extends boolean = true>(options: Options<AdminCreateCourseOptions, ThrowOnError>): Promise<UnwrappedResult<AdminCreateCourseResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'POST', url: '/admin/course/create', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<AdminCreateCourseResponses, ThrowOnError>>
}
